var $name="analytics/itemClick",$path="app/modules/analytics/itemClick.js",$this={$name,$path,};/**
 * @param { { selected_option: string}  } variables
 * @param { { selected_sub_option: string}  } variables
 */

/* eslint-disable camelcase */
function itemClickProvider({
  selected_option = '',
  selected_sub_option = '',
} = {}) {
  return {
    selected_option,
    selected_sub_option,
  };
}

// eslint-disable-next-line import/prefer-default-export
export { itemClickProvider };
